module.exports = __webpack_public_path__ + "img/import-modal-image.12276e52.png";